/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
import { ChevronDown, ChevronUp, Plus, RotateCw, Search } from 'lucide-react'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  InputGroup,
  Modal,
  OverlayTrigger,
  Popover,
  Row,
  Table
} from 'react-bootstrap'
import { Loader } from 'react-bootstrap-typeahead'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import Select from 'react-select'
import { BadgeStatusPrLists } from '../../../components/atoms/StatusLabel'
import TableAction from '../../../components/atoms/Table/TableAction'
import TablePagination from '../../../components/atoms/Table/TablePagination'
import InputDatePicker from '../../../components/Input/DatePicker/InputDatePicker'
import ModalAddSelectStagingArea from '../../../components/modal/ReceiveML/ModalAddSelectStagingArea'
import api from '../../../config/AxiosInstance'
import { convertDateWithTime } from '../../../helpers/constants'
import toast, { Toaster } from 'react-hot-toast'
import * as Common from '../../../utils/Common'

const headerTitleStyle = {
  color: 'var(--primary-orange)',
  fontSize: '24px',
  fontWeight: '600'
}

const tableHeaderStyle = {
  fontSize: '14px',
  fontWeight: '600',
  color: '#333333',
  letterSpacing: '0.5px',
  backgroundColor: '#f8f9fa',
  borderBottom: '2px solid #e9ecef'
}

const cardFilterStyle = {
  border: 'none',
  boxShadow: '0 2px 12px rgba(0,0,0,0.04)',
  borderRadius: '12px',
  padding: '1.5rem',
  marginBottom: '1.5rem',
  backgroundColor: '#fff'
}

const labelStyle = {
  fontSize: '0.75rem',
  fontWeight: '700',
  color: '#333333',
  textTransform: 'uppercase',
  marginBottom: '0.5rem',
  letterSpacing: '0.5px'
}

const SelectStyles = {
  control: (base, state) => ({
    ...base,
    height: 45,
    minHeight: 45,
    borderRadius: '10px',
    borderColor: state.isFocused ? 'var(--primary-orange)' : '#e9ecef',
    boxShadow: state.isFocused ? '0 0 0 4px rgba(248, 157, 29, 0.1)' : 'none',
    backgroundColor: '#ffffff',
    border: '1px solid #e9ecef',
    fontSize: '0.9rem'
  }),
  valueContainer: (provided, state) => ({
    ...provided,
    height: '45px',
    padding: '0 12px'
  }),
  input: (provided, state) => ({
    ...provided,
    margin: '0px'
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#495057'
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? 'var(--primary-orange)'
      : state.isFocused
        ? '#fff5e6'
        : null,
    color: state.isSelected ? 'white' : '#333',
    cursor: 'pointer'
  })
}

const FormControlStyle = {
  height: '45px',
  borderRadius: '10px',
  border: '1px solid #e9ecef',
  backgroundColor: '#ffffff',
  fontSize: '0.9rem'
}

function MaterialRejectPage() {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [icon, setIcon] = useState(() => ChevronDown)
  const [data, setData] = useState([])
  const refSrcWarehouses = useRef()
  const refDc = useRef()
  const [loading, setLoading] = useState({
    data: false
  })
  const [inboundId, setInboundId] = useState(null)
  const [dataDc, setDataDc] = useState([])
  const [modalStagingArea, setModalStagingArea] = useState(false)
  const [receiveWarehouses, setReceiveWarehouses] = useState([])
  const [selectWarehouseId, setSelectWarehouseId] = useState(null)
  const [visibleModal, setVisibleModal] = useState({
    selectDC: false
  })
  const [form, setForm] = useState({
    dc: null
  })
  const [filter, setFilter] = useState({
    mr_code: state?.mr_code || '',
    warehouse_id: state?.warehouse_id || '',
    start_date: state?.start_date || '',
    end_date: state?.end_date || ''
  })
  const [debouncedMrCode, setDebouncedMrCode] = useState(filter.mr_code)

  const [meta, setMeta] = useState({
    per_page: 10,
    current_page: 1,
    total_row: 0,
    total_page: 0
  })

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedMrCode(filter.mr_code)
      if (filter.mr_code !== debouncedMrCode) {
        setMeta((prev) => ({ ...prev, current_page: 1 }))
      }
    }, 1000)

    return () => {
      clearTimeout(handler)
    }
  }, [filter.mr_code])

  const renderStagingArea = (item) => {
    if (item.status === 'unassigned' && !item?.staging) {
      return (
        <div
          className="d-flex flex-row gap-2 justify-content-end cursor-pointer text-muted"
          role="button"
          onClick={() => handleModalStagingArea(item.id, item?.warehouse_name)}
        >
          <span>Staging Area</span>
          {modalStagingArea ? (
            <ChevronUp size={14} className="fa-flip-horizontal ml-2 mt-1" />
          ) : (
            <ChevronDown size={14} className="fa-flip-horizontal ml-2 mt-1" />
          )}
        </div>
      )
    }
    return (
      <OverlayTrigger
        trigger={['hover', 'click']}
        key={'bottom'}
        placement={'bottom'}
        overlay={
          <Popover id={`popover-positioned-bottom`}>
            <Popover.Body>
              <p>
                {item?.stagings?.map((staging) => staging.name)?.join(', ')}
              </p>
            </Popover.Body>
          </Popover>
        }
      >
        <div className="d-flex flex-row justify-content-end align-items-center">
          <p
            style={{ cursor: 'pointer', maxWidth: '80%', margin: 0 }}
            className="text-truncate"
          >
            {item?.stagings?.map((staging) => staging.name)?.join(', ')}
          </p>
        </div>
      </OverlayTrigger>
    )
  }
  const renderStatus = (item) => (
    <BadgeStatusPrLists
      text={item?.status ? item?.status?.replaceAll('_', ' ') : 'done'}
    />
  )
  const columns = [
    {
      key: 'created_at',
      label: 'Created',
      component: (item) => (
        <span className="text-muted">
          {convertDateWithTime(item.date, 'DD-MM-YYYY, HH:mm')}
        </span>
      )
    },
    {
      key: 'mr_code',
      label: '#MR',
      component: (item) => (
        <span className="fw-semibold text-primary">{item.mr_code}</span>
      )
    },
    {
      key: 'warehouse_name',
      label: 'Target Warehouse',
      component: (item) => (
        <span className="text-muted">{item.warehouse_name}</span>
      )
    },
    {
      key: 'customer',
      label: 'Customer',
      component: (item) => <span className="text-muted">{item.customer}</span>
    },
    {
      key: 'staging_area',
      label: 'Staging Area',
      component: (item) => renderStagingArea(item)
    },
    {
      key: 'status',
      label: 'Status',
      component: (item) => renderStatus(item)
    },
    {
      key: 'action',
      label: 'Action',
      component: (item) => (
        <TableAction>
          <Link
            to={`/inbound/material-reject/detail/${item.id}`}
            state={filter}
          >
            <Button
              variant="light"
              className="btn-sm border rounded text-secondary"
              style={{ width: '32px', height: '32px', padding: 0 }}
            >
              <Search size={13} />
            </Button>
          </Link>
        </TableAction>
      )
    }
  ]
  const handleChangeValueFilter = (e) => {
    const { name, value } = e?.target || e
    setFilter((filter) => ({ ...filter, [name]: value }))
  }

  const handleResetFilter = () => {
    setFilter({
      mr_code: '',
      warehouse_id: '',
      start_date: '',
      end_date: ''
    })
    setDebouncedMrCode('')
    refSrcWarehouses?.current?.clearValue()
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: 1
    }))
  }

  const handleForm = (e, name) => {
    setForm((prevForm) => ({
      ...prevForm,
      [name]: e
    }))
  }
  const handleOnChangeMeta = (e) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      per_page: parseInt(e.target.value, 10),
      current_page: 1
    }))
  }
  const fetchData = async () => {
    try {
      setLoading((prevLoading) => ({
        ...prevLoading,
        data: true
      }))
      const res = await api.get('/inbound/material-reject', {
        params: {
          ...filter,
          mr_code: debouncedMrCode,
          per_page: meta.per_page,
          page: meta.current_page
        }
      })
      const { data } = res
      if (data.success) {
        const { data: dataResponse, metadata: metaResponse } = data
        setData(
          dataResponse?.map((item) => ({
            ...item,
            status: item?.status === 'request_pnp' ? 'waiting_om' : item?.status
          }))
        )
        setMeta(metaResponse)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      toast.error(errMsg, {
        position: 'top-right',
        style: {
          fontSize: '14px',
          fontWeight: '600'
        }
      })
    } finally {
      setLoading((prevLoading) => ({
        ...prevLoading,
        data: false
      }))
    }
  }
  const handlePageChange = (data) => {
    setMeta((prevMeta) => ({
      ...prevMeta,
      current_page: data.selected + 1
    }))
    window.scrollTo(0, 0)
  }

  const fetchReceiverWarehouse = async () => {
    try {
      const response = await api.get('/master/warehouses/all?forUser=1')
      const { data } = response
      if (data.success) {
        setReceiveWarehouses(data.data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }
  const fetchDataDc = async () => {
    try {
      const response = await api.get('inbound/material-reject/all-dc')
      const { data } = response
      if (data.success) {
        setDataDc(data.data)
      }
    } catch (error) {
      const errMsg =
        error?.response?.data?.errors?.message || 'An error occurred'
      Common.showPopUpErrorMessage(errMsg)
    }
  }

  const createMR = () => {
    const stateValue = {
      dcId: form.dc,
      filter: { ...filter }
    }
    navigate('/inbound/material-reject/create', {
      replace: true,
      state: stateValue
    })
  }

  const handleModalStagingArea = (inboundId, warehouseId) => {
    setModalStagingArea(true)
    setInboundId(inboundId)
    setSelectWarehouseId(warehouseId)
  }

  const handleCloseFormCreate = () => {
    const checkVisible = Object.keys(visibleModal).find(
      (key) => visibleModal[key]
    )
    setVisibleModal((prevModal) => ({
      ...prevModal,
      [checkVisible]: !prevModal[checkVisible]
    }))
    setForm((prevForm) => ({
      ...prevForm,
      dc: null
    }))
  }
  const getModalTitleForm = () => {
    if (visibleModal.selectDC) {
      return {
        title: 'Select DC',
        size: 'md'
      }
    }
    return {
      title: '',
      size: 'md'
    }
  }

  useEffect(() => {
    fetchData()
  }, [
    debouncedMrCode,
    filter.warehouse_id,
    filter.start_date,
    filter.end_date,
    meta.per_page,
    meta.current_page
  ])

  useEffect(() => {
    if (!receiveWarehouses.length) {
      fetchReceiverWarehouse()
    }
  }, [])

  useEffect(() => {
    if (visibleModal.selectDC) {
      fetchDataDc()
    }
  }, [visibleModal])

  return (
    <>
      <Toaster />
      <Container fluid className="px-4">
        <Row className="mb-4 align-items-center">
          <Col>
            <div className="d-flex justify-content-between align-items-center">
              <h3 style={headerTitleStyle}>Material Reject</h3>
              <div className="d-flex gap-2">
                <Button
                  variant="light"
                  className="text-secondary fw-bold rounded px-3 border"
                  onClick={handleResetFilter}
                  style={{ fontSize: '0.85rem' }}
                >
                  <RotateCw size={14} className="me-2" />
                  Reset Filters
                </Button>
                <Button
                  className="btn btn-primary-blue rounded px-3"
                  onClick={() =>
                    setVisibleModal((prevVisibleModal) => ({
                      ...prevVisibleModal,
                      selectDC: !prevVisibleModal.selectDC
                    }))
                  }
                >
                  <Plus size={14} />
                  <span className="ms-2 fw-bold">Create Material Reject</span>
                </Button>
              </div>
            </div>
          </Col>
        </Row>

        <Card style={cardFilterStyle}>
          <Row className="g-3">
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle} htmlFor="q">
                  #material reject
                </Form.Label>
                <InputGroup>
                  <InputGroup.Text
                    style={{
                      backgroundColor: '#f8f9fa',
                      border: '1px solid #e9ecef',
                      borderRight: 'none',
                      borderTopLeftRadius: '10px',
                      borderBottomLeftRadius: '10px'
                    }}
                  >
                    <Search size={16} className="text-muted" />
                  </InputGroup.Text>
                  <Form.Control
                    type="text"
                    id="mr_code"
                    name="mr_code"
                    value={filter.mr_code}
                    onChange={(e) => handleChangeValueFilter(e)}
                    placeholder="Search Material Reject..."
                    style={{
                      ...FormControlStyle,
                      borderLeft: 'none',
                      borderTopLeftRadius: 0,
                      borderBottomLeftRadius: 0
                    }}
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group controlId="sjdelivend">
                <Form.Label style={labelStyle}>RECEIVER WAREHOUSE</Form.Label>
                <Select
                  isClearable
                  id="warehouse"
                  defaultValue={filter?.warehouse_id || ''}
                  styles={SelectStyles}
                  onChange={(e) => {
                    if (!e) {
                      e = {
                        target: refSrcWarehouses,
                        value: ''
                      }
                    }
                    handleChangeValueFilter({
                      value: e?.value,
                      name: 'warehouse_id'
                    })
                    setMeta((prev) => ({ ...prev, current_page: 1 }))
                  }}
                  options={receiveWarehouses.map((warehouse) => {
                    return {
                      value: warehouse.id,
                      label: warehouse.warehouse_name
                    }
                  })}
                  placeholder="Select Warehouse"
                  isSearchable
                  ref={refSrcWarehouses}
                />
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>Start Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter?.start_date}
                    onChange={(date) => {
                      const newDate = date
                        ? moment(date).format('YYYY-MM-DD')
                        : ''
                      setFilter((filter) => {
                        const newFilter = { ...filter, start_date: newDate }
                        if (
                          newDate &&
                          filter.end_date &&
                          moment(newDate) > moment(filter.end_date)
                        ) {
                          newFilter.end_date = newDate
                        }
                        return newFilter
                      })
                      setMeta((prev) => ({ ...prev, current_page: 1 }))
                    }}
                    maxDate={filter.end_date ? new Date(filter.end_date) : null}
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
            <Col md={3}>
              <Form.Group>
                <Form.Label style={labelStyle}>End Date</Form.Label>
                <div
                  style={FormControlStyle}
                  className="d-flex align-items-center px-2"
                >
                  <InputDatePicker
                    value={filter?.end_date}
                    onChange={(date) => {
                      const newDate = date
                        ? moment(date).format('YYYY-MM-DD')
                        : ''
                      setFilter((filter) => {
                        const newFilter = { ...filter, end_date: newDate }
                        if (
                          newDate &&
                          filter.start_date &&
                          moment(newDate) < moment(filter.start_date)
                        ) {
                          newFilter.start_date = newDate
                        }
                        return newFilter
                      })
                      setMeta((prev) => ({ ...prev, current_page: 1 }))
                    }}
                    minDate={
                      filter.start_date ? new Date(filter.start_date) : null
                    }
                    clearIcon
                  />
                </div>
              </Form.Group>
            </Col>
          </Row>
        </Card>

        <Row className="mt-3">
          <Table
            hover
            responsive
            className="shadow-sm mb-5 bg-white"
            style={{
              borderRadius: '12px',
              overflow: 'hidden',
              fontSize: '0.9rem'
            }}
          >
            <thead style={{ backgroundColor: '#f8f9fa' }}>
              <tr>
                {columns.map((column) => (
                  <th
                    className="align-middle p-2"
                    key={column.key}
                    style={tableHeaderStyle}
                  >
                    <span>{column.label}</span>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody style={{ fontSize: '12px' }}>
              {loading.data && (
                <tr>
                  <td colSpan={columns.length} className="text-center p-5">
                    <Loader />
                  </td>
                </tr>
              )}
              {!loading.data && !data.length && (
                <tr>
                  <td
                    colSpan={columns.length}
                    className="text-center fw-bold p-5 text-muted"
                  >
                    No Data Found
                  </td>
                </tr>
              )}
              {!loading.data &&
                data.length > 0 &&
                data.map((item, index) => (
                  <tr
                    key={`${item.id}-${index}`}
                    style={{ borderBottom: '1px solid #f0f0f0' }}
                  >
                    {columns.map((column) => (
                      <td key={column.key} className="p-2 align-middle">
                        {column.component
                          ? column.component(item)
                          : item[column.key]}
                      </td>
                    ))}
                  </tr>
                ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={8} className="p-3 border-top-0">
                  <TablePagination
                    meta={meta}
                    handleOnChangeMeta={handleOnChangeMeta}
                    handlePageChange={handlePageChange}
                  />
                </td>
              </tr>
            </tfoot>
          </Table>
        </Row>
        <ModalAddSelectStagingArea
          show={modalStagingArea}
          onHide={() => {
            setModalStagingArea(false)
            setSelectWarehouseId('')
            setInboundId(null)
          }}
          warehouseId={selectWarehouseId}
          inboundId={inboundId}
          refreshData={() => fetchData()}
          type="material-reject"
        />
        <Modal
          show={Object.keys(visibleModal).find(
            (key) => visibleModal[key] === true
          )}
          centered
          size={getModalTitleForm()?.size}
          onHide={handleCloseFormCreate}
        >
          <Modal.Header closeButton>
            <Modal.Title>{getModalTitleForm()?.title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form.Group controlId="sjdelivend">
              <Form.Label className="fw-bold text-secondary" controlId="dc">
                <small>#DC</small>
              </Form.Label>
              <Select
                id="dc"
                name="dc"
                options={dataDc.map((dc) => {
                  return {
                    value: dc.dc_id,
                    label: dc.wms_dc_no
                  }
                })}
                onChange={(e) => handleForm(e, 'dc')}
                value={form.dc}
                placeholder="Search DC..."
                isClearable
                isSearchable
                ref={refDc}
                styles={SelectStyles}
              />
            </Form.Group>
          </Modal.Body>
          <div className="d-flex justify-content-end w-100 my-2">
            <Button variant="transparent" onClick={handleCloseFormCreate}>
              Close
            </Button>
            <Button
              variant="transparent"
              className={
                form.dc ? 'btn-primary-orange' : 'btn-secondary opacity-50'
              }
              disabled={!form.dc}
              onClick={createMR}
            >
              Create
            </Button>
          </div>
        </Modal>
      </Container>
    </>
  )
}

export default MaterialRejectPage
